import { render, staticRenderFns } from "./MyLoanPage.vue?vue&type=template&id=70d98a80&scoped=true"
import script from "./MyLoanPage.vue?vue&type=script&lang=js"
export * from "./MyLoanPage.vue?vue&type=script&lang=js"
import style0 from "./MyLoanPage.vue?vue&type=style&index=0&id=70d98a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d98a80",
  null
  
)

export default component.exports